<template>
  <b-modal
    v-model="show"
    :centered="true"
    size="md"
    title="Edit Billing Entry"
    :no-close-on-backdrop="true"
  >
    <b-form-group label="Charge Label">
      <b-form-input v-model="form.chargeLabel" />
    </b-form-group>
    <b-form-group label="Number of Units">
      <b-form-input type="number" step="0.01" min="0.01" v-model="form.numberOfUnits" />
    </b-form-group>
    <b-form-group label="Single Unit Charge (USD)">
      <b-form-input type="number" step="0.01" min="0" v-model="form.singleUnitCharge" />
    </b-form-group>
    <template v-slot:modal-footer>
      <div class="w-100">
        <b-button variant="primary" class="mr-1" :disabled="saving" @click="save">
          <span v-if="saving"><i class="fa fa-spinner fa-spin mr-1"></i>Saving...</span>
          <span v-else>Save</span>
        </b-button>
        <b-button variant="outline-secondary" @click="show = false">Cancel</b-button>
      </div>
    </template>
  </b-modal>
</template>

<script>
export default {
  name: 'EditBillingEntryModal',
  props: {
    value: {
      type: Boolean,
      default: false
    },
    entry: {
      type: Object,
      default: null
    }
  },
  data() {
    return {
      saving: false,
      form: {
        chargeLabel: '',
        numberOfUnits: 0,
        singleUnitCharge: 0
      }
    };
  },
  computed: {
    show: {
      get() { return this.value; },
      set(val) { this.$emit('input', val); }
    }
  },
  watch: {
    value(val) {
      if (val && this.entry) {
        this.form.chargeLabel = this.entry.chargeLabel || '';
        this.form.numberOfUnits = this.entry.numberOfUnits || 0;
        this.form.singleUnitCharge = this.entry.singleUnitCharge || 0;
      }
    }
  },
  methods: {
    save() {
      if (!this.form.chargeLabel) {
        this.$swal('Validation', 'Charge Label is required.', 'warning');
        return;
      }
      if (this.form.numberOfUnits <= 0) {
        this.$swal('Validation', 'Number of Units must be greater than 0.', 'warning');
        return;
      }
      if (this.form.singleUnitCharge < 0) {
        this.$swal('Validation', 'Single Unit Charge cannot be negative.', 'warning');
        return;
      }
      this.saving = true;
      this.$http.put('/api/common/orderBillingEntries/', {
        id: this.entry.id,
        chargeLabel: this.form.chargeLabel,
        numberOfUnits: parseFloat(this.form.numberOfUnits),
        singleUnitCharge: parseFloat(this.form.singleUnitCharge)
      }).then((resp) => {
          this.saving = false;
          this.show = false;
          this.$emit('saved', resp.data && resp.data ? resp.data : null);
        })
        .catch((err) =>{
          this.saving = false;
          var msg = (err.response && err.response.data && err.response.data.errorMessage) || 'An error occurred while saving.';
          this.$swal('Error', msg, 'error');
        });
    }
  }
};
</script>
